import React from 'react';
import Footer from './common/Footer';

const CopyrightNotice = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-900 relative overflow-hidden">
      <div className="flex-grow flex flex-col items-center py-12 px-4 sm:px-6 lg:px-8">
        {/* Logo Section */}
        <div className="w-full max-w-lg mb-8">
          <div className="flex flex-col items-center relative z-10">
            <img
              src="/images/imr-logo.png"
              alt="IMR Logo"
              className="h-32 w-auto mb-4"
            />
            <h1 className="text-center text-2xl font-bold text-yellow-500">
              DEFENCE INDUSTRY DIRECTORY
            </h1>
          </div>
        </div>

        {/* Copyright Notice Content */}
        <div className="w-full max-w-4xl relative z-10">
          <div className="bg-gray-800/90 shadow-lg rounded-lg p-8 border border-gray-700 backdrop-blur-sm text-gray-300">
            <h2 className="text-2xl font-bold text-yellow-500 mb-6">Copyright Notice</h2>
            <p className="text-sm mb-4">Effective Date: 1 June 2025</p>
            
            <div className="space-y-6">
              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">Copyright Protection</h3>
                <p className="mb-4">
                  The content, design, graphics, and other materials on this website are protected by copyright and other intellectual property laws. 
                  Unauthorized use, reproduction, or distribution of any material from this site is strictly prohibited without the express written 
                  permission of IMR Media Pvt Ltd.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">Permission Requests</h3>
                <p className="mb-4">
                  For permissions or inquiries regarding the use of content from this site, please contact us at{' '}
                  <a href="mailto:directory@defencepartners.in" className="text-yellow-500 hover:text-yellow-400 transition-colors duration-200">
                    directory@defencepartners.in
                  </a>. 
                </p>
                <p className="mb-4">
                  To report copyright infringement, please reach out to the same address.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">Permitted Uses</h3>
                <p className="mb-4">
                  For more information on permitted uses, please refer to our{' '}
                  <a href="/terms" className="text-yellow-500 hover:text-yellow-400 transition-colors duration-200">
                    Terms and Conditions
                  </a>.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">Additional Information</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>All trademarks and logos displayed on this website are the property of their respective owners.</li>
                  <li>The directory content and company information are proprietary to IMR Media Pvt Ltd.</li>
                  <li>Any unauthorized commercial use of the website content is strictly prohibited.</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">Contact</h3>
                <p>
                  For any questions about this Copyright Notice or to report potential violations, please contact us at{' '}
                  <a href="mailto:directory@defencepartners.in" className="text-yellow-500 hover:text-yellow-400 transition-colors duration-200">
                    directory@defencepartners.in
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CopyrightNotice;
